module.exports = __webpack_public_path__ + "img/module_record.94e568db.jpg";